import React, { Component } from 'react'
import { Row, Col } from 'antd'

const DemoBox = props => <p className={`height-${props.value}`}>{props.children}</p>;

class AdminHome extends Component {

    render() {
        return (
            <Row type="flex" justify="space-around" align="middle">
                <Col span={1}>
                    <DemoBox value={120}>
                        Admin Home
                    </DemoBox>
                </Col>
            </Row>
        )
    }
}

export default AdminHome;



// WEBPACK FOOTER //
// ./src/components/AdminHome.js